function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_4256",
  "data-name": "Group 4256",
  transform: "translate(-136 -602.702)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_1",
  "data-name": "Union 1",
  d: "M.906,8.214a.906.906,0,0,1,0-1.813H19.562L14.708,1.547A.906.906,0,1,1,15.989.266l5.554,5.554a.907.907,0,0,1,.129,1.12.907.907,0,0,1-.828,1.275Z",
  transform: "translate(136 602.702)",
  fill: "#f86542"
}), /*#__PURE__*/React.createElement("path", {
  id: "Union_2",
  "data-name": "Union 2",
  d: "M.906,8.214a.906.906,0,0,1,0-1.813H19.562L14.708,1.547A.906.906,0,1,1,15.989.266l5.554,5.554a.907.907,0,0,1,.129,1.12.907.907,0,0,1-.828,1.275Z",
  transform: "translate(157.809 623) rotate(180)",
  fill: "#f86542"
}));

var SvgIconOrder = function SvgIconOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21.809 20.298",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-order.a1a517d1.svg";
export { ForwardRef as ReactComponent };